import { useCallback } from 'react';
import { pick } from 'ramda';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'js/store/hooks';
import { LAYER } from 'js/components/common/PopupManager/layers';
import { POPUP_IDS } from 'js/components/common/PopupManager/constants';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';

export const useHandleUserVerify = () => {
    const dispatch = useDispatch();
    const { wcIdForSuspendedPlayer, wcIdForNotSuspendedPlayer } = useAppSelector(pick(['wcIdForSuspendedPlayer', 'wcIdForNotSuspendedPlayer']));

    return useCallback((isSuspended: boolean): void => {
        dispatch(showCommonPopupAction({
            isModal: isSuspended,
            articleId: isSuspended ? wcIdForSuspendedPlayer : wcIdForNotSuspendedPlayer,
            buttons: [],
            closeAll: true,
            layer: LAYER.HIGH_PRIORITY,
            id: POPUP_IDS.USER_VERIFY_POPUP
        }));
    }, [dispatch, wcIdForSuspendedPlayer, wcIdForNotSuspendedPlayer]);
};
